module.exports = __webpack_public_path__ + "1d781d6af2874607c870ea77ebc65676.svg";